// LAP — palette de statuts unifiée pour Mes ToDo (synthèse + listes).
// Une seule source de vérité pour les couleurs de statut, utilisée par les
// graphes de la synthèse (fond sombre) et les puces de statut des listes
// (fond blanc). Remplace les 'blue'/'red'/'green' bruts dispersés.

export const STATUS_COLORS = {
  notStarted: '#8aa4b8',
  inProgress: '#3b82f6',
  late: '#ef4444',
  done: '#22c55e',
}

// Ordre historique des datasets : Non démarré / En cours / En retard / Terminées
export const STATUS_SERIES = [
  STATUS_COLORS.notStarted,
  STATUS_COLORS.inProgress,
  STATUS_COLORS.late,
  STATUS_COLORS.done,
]

// Métadonnées d'affichage d'un statut de tâche (libellé traduit + couleurs
// pour une puce sur fond clair). `t` = fonction i18n du namespace layout.
export function getStatutMeta(statut, t) {
  if (statut === 'Fait') {
    return { text: t('mesToDo.statusDone'), color: '#15803d', bg: '#dcfce7' }
  }
  if (statut === 'En-retard') {
    return { text: t('mesToDo.statusLate'), color: '#b91c1c', bg: '#fee2e2' }
  }
  if (statut === 'En-Cours') {
    return { text: t('mesToDo.statusInProgress'), color: '#1d4ed8', bg: '#dbeafe' }
  }
  return { text: t('mesToDo.statusNotStarted'), color: '#475569', bg: '#e2e8f0' }
}
